export const fields = {
    email: 'email',
    password: 'password',
    confirmPassword: 'confirm password',
    postalCode: 'postal code',
    latitude: 'latitude',
    longitude: 'longitude',
    category: 'category',
    firstName: 'first name',
    lastName: 'last name',
    phoneNumber: 'phone number',
    country: 'country',
    city: 'city',
    company: 'company',
    jobTitle: 'job title',
    timezone: 'timezone',
    address: 'address',
    countryId: 'country',
    ldapUsername: 'ldap username',
    language: 'language',
    module: 'module',
    projectName: 'project name',
    profileName: 'profile name',
    projectAdminEmail: 'project admin email',
    name: 'name',
    exportFormat: 'export format',
    securityProfile: 'constellation profile',
    description: 'description',
    reason: 'reason',
    permissions: 'permissions',
    currentPassword: 'current password',
    groupName: 'group name',
    pbsGroupName: 'pbs group name',
    projectProfile: 'project profile',
    viewer3dProfile: '3D viewer profile',
    subject: 'subject',
    priority: 'priority',
    version: 'version',
    site: 'site',
    ldapServerUrl: 'LDAP server',
    ldapAdminDn: 'admin distinguished name',
    ldapAdminPassword: 'admin password',
    ldapBaseUsersDn: 'base users',
    adminId: 'admin',
    user: 'user',
    id: 'ID',
    status: 'Status',
    type: 'Type',
    taskType: 'Type',
    parentId: 'Parent ID',
    parentName: 'Parent name',
    calendarName: 'Calendar name',
    start: 'Start',
    actualStart: 'Actual start',
    earlyStart: 'Early start',
    lateStart: 'Late start',
    plannedStart: 'Planned start',
    blStart: 'BL start',
    finish: 'Finish',
    actualFinish: 'Actual finish',
    earlyFinish: 'Early finish',
    lateFinish: 'Late finish',
    plannedFinish: 'Planned finish',
    blFinish: 'BL finish',
    prConstraint: 'Primary constraint',
    prConstraintDate: 'Primary constraint date',
    expectedFinish: 'Expected finish',
    durationType: 'Duration type',
    originalDuration: 'Original duration',
    actualDuration: 'Actual duration',
    remainingDuration: 'Remaining duration',
    atCompleteDuration: 'At complete duration',
    blDuration: 'BL duration',
    VBLDuration: 'Variance BL duration',
    VBLFinishDate: 'Variance BL Finish Date',
    VBLStartDate: 'Variance BL Start Date',
    freeFloat: 'Free float',
    totalFloat: 'Total float',
    critical: 'Critical',
    percentageComplete: 'Percent complete type',
    physicalPercentage: 'Physical % Complete',
    durationPercentage: 'Duration % Complete',
    manualPercentage: 'Manual % Complete',
    physicalUnit: 'Physical quantity unit',
    physicalQuantity: 'Physical quantity',
    actualPhysicalQuantity: 'Actual physical quantity',
    remainPhysicalQuantity: 'Remaining physical quantity',
    rules: 'Rules',
    code: 'Code',
    appearanceProfile: 'Appreance profile',
    resouce3D: 'Resource 3D',
    resource: 'Resource',
    resourceGroup: 'Resource group',
    baselineName: 'Baseline name',
    manualComplete: 'Manual % complete',
    activityName: 'Activity name',
    activityType: 'Activity type',
    activityStatus: 'Activity status',
    primaryConstraints: 'Primary constraint',
    fieldName: 'Field name',
    dataType: 'Data type',
    colorCode: 'Color',
    taskIdPrefix: 'Task ID prefix',
    taskIdSuffix: 'Task ID suffix',
    taskIdIncrement: 'Task ID increment',
    currency: 'Currency',
    projectStart: 'Project start',
    durationFormat: 'Duration format',
    defaultDuration: 'Default duration',
    dataDate: 'Data date',
    defaultCalendar: 'Default calendar',
    planningId: 'Planning ID',
    planningName: 'Planning name',
    fileName: 'File name',
    unit: 'Unit',
    calendar: 'Calendar',
    effectiveDate: 'Effective date',
    price: 'Price',
    dayType: 'Day type',
    workingDayTypeId: 'Working day type',
    hoursPerDay: 'Hours/day',
    hoursPerWeek: 'Hours/week',
    hoursPerMonth: 'Hours/month',
    hoursPerYear: 'Hours/year',
    value: 'Value',
    startAppearanceProfile: {
        colorValue: 'color',
        transparencyValue: 'transparency',
    },
    activeAppearanceProfile: {
        colorValue: 'color',
        transparencyStartValue: 'start transparency',
        transparencyEndValue: 'end transparency',
    },
    endAppearanceProfile: {
        colorValue: 'color',
        transparencyValue: 'transparency',
    },
    activeGrowthSimulation: {
        type: 'type',
        direction: 'direction',
    },
    color: 'color',
    mode: 'mode',
    objects: 'objects',
    fromDate: 'from date',
    toDate: 'to date',
    intervals: 'number of intervals',
    timeBaseTaskId: 'time base task',
    computeIntersectionCurve: 'intersection curve',
    computeIntersectionVolume: 'intersection volume',
    computeIntersectionDepth: 'intersection depth',
    computeContactCollisionThreshold: 'contact/collision threshold',
    computeClashFor: 'compute clash for',
    combineGeometries: 'combine geometries',
    visualizationIntersectionCurve: 'intersection curve',
    visualizationIntersectionVolume: 'intersection volume',
    visualizationIntersectionDepth: 'penetration depth',
    clashIntersectionCurveColor: 'clash intersection curve',
    contactIntersectionCurveColor: 'contact intersection curve',
    intersectionVolumeColor: 'intersection volume',
    penetrationDepthColor: 'penetration depth',
    unitOfMeasurement: 'unit of measurement',
    showClashBy: 'show clash by',
    zoomFit: 'zoom fit',
    zoomFactor: 'zoom factor',
    clashPairTransparency: 'clash pair transparency',
    nameUsedForClashPairs: 'name used for clash pairs',
};
